import adhese from './adhese';
import def from './default';
import improvedigital from './improvedigital';
import msft from './msft';
import rubicon from './rubicon';

export default {
	'default': def,
	rubicon,
	improvedigital,
	'imprweborama': improvedigital,

	msft,
	appnexus: msft,
	'gps': msft,
	'gps-msft': msft,
	'plista': msft,
	'plista-msft': msft,
	'groupm': msft,
	'groupm-msft': msft,
	'weborama': msft,
	'weborama-msft': msft,

	'adhese': adhese,

};
